import script from "./categoryType.vue?vue&type=script&setup=true&lang=ts"
export * from "./categoryType.vue?vue&type=script&setup=true&lang=ts"

import "./categoryType.vue?vue&type=style&index=0&id=1ae9d21f&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae9d21f"]])

export default __exports__